export default __webpack_public_path__ + "static/media/fridge1-before2-1440w.0ebf731f.webp";